<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { numeric, required } from '@vuelidate/validators';
import { shouldBeUrl } from 'shared/helpers/Validators';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiId: '',
      apiHash: '',
      gatewayUrl:
        window.chatwootConfig?.telegramPersonalGatewayUrl ||
        'http://telegram_personal_gateway:3200',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required },
    apiId: { required, numeric },
    apiHash: { required },
    gatewayUrl: { required, shouldBeUrl },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const telegramChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'telegram_personal',
              display_name: this.inboxName?.trim(),
              provider_config: {
                api_id: this.apiId?.trim(),
                api_hash: this.apiHash?.trim(),
                phone_number: this.phoneNumber?.trim(),
                gateway_url: this.gatewayUrl?.trim(),
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: telegramChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <p class="mb-6 text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.DESCRIPTION') }}
    </p>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="tel"
          :placeholder="
            $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.PHONE_NUMBER.PLACEHOLDER')
          "
          @blur="v$.phoneNumber.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiId.$error }">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.API_ID.LABEL') }}
        <input
          v-model="apiId"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          :placeholder="
            $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.API_ID.PLACEHOLDER')
          "
          @blur="v$.apiId.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiHash.$error }">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.API_HASH.LABEL') }}
        <input
          v-model="apiHash"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.API_HASH.PLACEHOLDER')
          "
          @blur="v$.apiHash.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.gatewayUrl.$error }">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.GATEWAY_URL.LABEL') }}
        <input
          v-model="gatewayUrl"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.GATEWAY_URL.PLACEHOLDER')
          "
          @blur="v$.gatewayUrl.$touch"
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.TELEGRAM_PERSONAL.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
